import { Button, Typography } from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import { ReactComponent as Wave1 } from "assets/Course/wave-1.svg"
import { ReactComponent as Wave2 } from "assets/Course/wave-2.svg"
import clsx from "clsx"
import { useEffect, useState } from "react"
import Lottie from "react-lottie"
import { useNavigate } from "react-router-dom"
import routes from "routes"
import { learningItemSlugs } from "utils/constants"
import { breakpoints } from "utils/createBreakpoints"
import { getPlatformURL } from "utils/helpers"
import { useEnrollments } from "utils/hooks/useEnrollments"

import styles from "./CompletedCourseCard.module.css"

type Props = {
  className?: string
  serialNumber?: string | null
  hasGradebook: boolean
  isCourseCompleted: boolean
  learningItemId: number
}

const CompletedCourseCard = ({
  className,
  serialNumber,
  hasGradebook,
  isCourseCompleted,
  learningItemId,
}: Props) => {
  const isXsDown = useMediaQuery(breakpoints.down("xs"))
  const navigate = useNavigate()

  const [confetti, setConfetti] = useState<object | null>(null)

  useEffect(() => {
    import("assets/Course/confetti.json").then(mod => setConfetti(mod.default))
  }, [])

  const enrollments = useEnrollments()
  const parentSlug = enrollments.data?.find(item => item.id === learningItemId)
    ?.parents?.[0]?.slug

  const isPgCTLCourse = parentSlug === learningItemSlugs.pgctl
  const isNewDeliveryMode = enrollments.pgctl.isNewDeliveryMode

  if (serialNumber) {
    return (
      <div
        className={clsx(
          "relative flex !cursor-default flex-col items-center justify-between  overflow-hidden rounded-2xl p-0 sm:flex-row sm:p-3",
          styles.containerBackground,
          className
        )}
      >
        <div className="absolute z-2 !cursor-default">
          {confetti && (
            // @ts-expect-error react version issues
            <Lottie
              isClickToPauseDisabled
              style={{
                cursor: "default",
              }}
              options={{
                loop: true,
                autoplay: true,
                animationData: confetti,
              }}
            />
          )}
        </div>

        <Wave1 className="absolute right-0 z-1" />
        <Wave2 className="absolute right-0" />

        <Typography
          className="z-3 mx-2 mb-2 mt-2.5 text-success-500 sm:m-0"
          variant="title3"
        >
          Congratulations! You have {!isXsDown && <br />}
          completed the course
        </Typography>
        <a
          href={getPlatformURL("suraasa", `/verify/${serialNumber}`)}
          target="_blank"
          rel="noreferrer"
        >
          <Button className={clsx("z-4", styles.viewCertificate)} size="sm">
            View Certificate
          </Button>
        </a>
      </div>
    )
  }
  if (isPgCTLCourse && isNewDeliveryMode && isCourseCompleted && hasGradebook) {
    return (
      <div className="flex flex-col rounded-2xl border bg-[linear-gradient(270deg,#CE3E3E66_0%,#FFF6F9_48%)]">
        <div className="flex flex-col items-start justify-between sm:flex-row sm:items-center">
          <div className="m-3 flex flex-col items-start">
            <Typography variant="title3" className="mb-0.25 text-critical-500">
              You&apos;ve completed the course!
            </Typography>
            <Typography variant="smallBody" className="mb-1 text-critical-500">
              Certificate not awarded: Your GPA is below the required 5.0.
            </Typography>
            <Typography variant="smallBody" className="text-critical-700">
              For assistance, contact care@suraasa.com
            </Typography>
          </div>

          <Button
            color="critical"
            size="sm"
            className="mr-6 w-full rounded-none rounded-b-[16px] bg-critical-500 sm:w-auto sm:rounded"
            onClick={() => {
              const path = routes.parentItemGradebook
                .replace(":learningItemType", "qualification")
                .replace(":slug", parentSlug)

              navigate(path)
            }}
          >
            View Grades
          </Button>
        </div>
      </div>
    )
  }
}
export default CompletedCourseCard
